import {
  createComponentPreviewMapperModel,
  withCompPreviewInfo,
  withCompPreviewProps,
} from '@wix/editor-elements-integrations';
import { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import type {
  CompPreviewInfoDependency,
  MediaContainerPreviewProps,
  MediaCSSVars,
} from '@wix/thunderbolt-components-native';
import {
  css as mediaContainerCssMapper,
  getFillLayersPreviewProps,
} from '../../../MediaContainers/MediaContainer/viewer/MediaContainer.previewMapper';
import type {
  ISectionProps,
  SectionDefinition,
  ISectionPreviewMapperProps,
} from '../Section.types';

export const props = withCompPreviewProps<
  PreviewWrapperProps<ISectionProps, ISectionPreviewMapperProps>,
  SectionDefinition,
  ISectionProps
>()(
  ['isPlayingAllowed', 'compDesign', 'componentViewMode'],
  (data, carmiData: ISectionProps) => {
    const { background } = carmiData;
    if (!background) {
      return carmiData;
    }
    const mediaContainerProps = getFillLayersPreviewProps(
      { fillLayers: background } as MediaContainerPreviewProps,
      data,
    );
    return {
      ...carmiData,
      background: { ...mediaContainerProps.fillLayers },
      ...mediaContainerProps,
    };
  },
);

const mediaContainerCssDeps = Object.keys(
  mediaContainerCssMapper.deps,
) as Array<CompPreviewInfoDependency>;

const css = withCompPreviewInfo<
  MediaCSSVars,
  SectionDefinition,
  MediaCSSVars
>()([...mediaContainerCssDeps], (deps, carmiData) => {
  const mediaContainerCss = mediaContainerCssMapper.resolver(deps, carmiData);
  return {
    ...mediaContainerCss,
    '--inherit-transition': 'var(--transition, none)',
  };
});

export default createComponentPreviewMapperModel({
  props,
  css,
});
